module.exports = __webpack_public_path__ + "static/media/todo.1de5b6ea.png";